import { render, staticRenderFns } from "./elevatorVideo.vue?vue&type=template&id=12745719&scoped=true&"
import script from "./elevatorVideo.vue?vue&type=script&lang=js&"
export * from "./elevatorVideo.vue?vue&type=script&lang=js&"
import style0 from "./elevatorVideo.vue?vue&type=style&index=0&id=12745719&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12745719",
  null
  
)

export default component.exports